import { render, staticRenderFns } from "./ExtraSwitch.vue?vue&type=template&id=787947f4&scoped=true&"
import script from "./ExtraSwitch.vue?vue&type=script&lang=js&"
export * from "./ExtraSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ExtraSwitch.vue?vue&type=style&index=0&id=787947f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787947f4",
  null
  
)

export default component.exports